import api from './api';

export const getDocuments = () => {
    return api.get('/v1/cp/documents')
}
export const getDocumentSas = (id, number = 1) => {
    return api.get(`/v1/cp/documents/${id}?fileNumber=${number}`)
}
export const uploadDocuments = (params) => {
    return api.post('/v1/cp/documents', params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}

export const uploadFundDocuments = (accountId, propValue, params) => {
    return api.post(`/v1/cp/documents/fundDeposits/${accountId}?gateway=${propValue}`, params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}
export const sendAgreement = (params) => {
    return api.post('/v1/cp/documents/swapFree', params)
}

export const sendBonusAgreement = (params) => {
    return api.post('/v1/cp/documents/bonus', params);
}
